import { create } from 'zustand'

import {
  DeviceAvailability,
  DeviceSortType,
  PriceRange,
  SortOrder
} from '@/lib/types'

export const DEFAULT_PREORDER = null
export const DEFAULT_LOCATION_ID = null

const DEFAULT_FILTER_VALUES = {
  totalPrice: { from: null, to: null },
  pricePerTH: { from: null, to: null },
  locationId: DEFAULT_LOCATION_ID,
  preorder: DEFAULT_PREORDER,
  order: 'asc' as SortOrder,
  sort: 'price' as DeviceSortType
}

export interface DeviceFilterStore {
  maxPrice?: number
  maxPricePerTH?: number
  preorder: DeviceAvailability
  locationId: number | null
  totalPrice: PriceRange
  pricePerTH: PriceRange
  sort?: DeviceSortType
  order?: SortOrder
  setPreorder: (preorder: DeviceAvailability) => void
  setLocationId: (locationId: number | null) => void
  setPrices: ({
    totalPrice,
    pricePerTH
  }: {
    totalPrice: PriceRange
    pricePerTH: PriceRange
  }) => void
  reset: () => void
  reorder: ({ order, sort }: { order: SortOrder; sort: DeviceSortType }) => void
}

export const useDeviceFilterStore = create<DeviceFilterStore>((set) => ({
  ...DEFAULT_FILTER_VALUES,
  reset: () => set({ ...DEFAULT_FILTER_VALUES }),
  setPreorder: (preorder) => set({ preorder }),
  setLocationId: (locationId) => set({ locationId }),
  setPrices: ({ totalPrice, pricePerTH }) => set({ totalPrice, pricePerTH }),
  reorder: ({ order, sort }: { order: SortOrder; sort: DeviceSortType }) =>
    set({ order, sort })
}))
